exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transition-width-height[data-v-59c172da] {\n    transition: width 0.5s ease-in-out, height 0.5s ease-in-out;\n}\n\n", ""]);

// exports
